import { Card } from 'antd';
import { useEffect } from 'react';

declare global {
  interface Window {
    hbspt: any;
  }
}

const BuyersAgentHubSpotForm = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '23436755',
          formId: '602e49f3-59d4-41b1-878b-2d60e2119a21',
          region: 'na1',
          target: '#hubspot-form',
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Cleanup script on unmount
    };
  }, []);

  return (
    <Card>
      <div id="hubspot-form"></div>
    </Card>
  );
};

export default BuyersAgentHubSpotForm;
